const DOCUMENT = 'INTERVIEW_';

const actions = {
  APPROVE_APPLICANT: DOCUMENT + 'APPROVE_APPLICANT',
  APPROVE_APPLICANT_FAIL: DOCUMENT + 'APPROVE_APPLICANT_FAIL',
  APPROVE_APPLICANT_SUCCESS: DOCUMENT + 'APPROVE_APPLICANT_SUCCESS',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  DENY_APPLICANT: DOCUMENT + 'DENY_APPLICANT',
  DENY_APPLICANT_FAIL: DOCUMENT + 'DENY_APPLICANT_FAIL',
  DENY_APPLICANT_SUCCESS: DOCUMENT + 'DENY_APPLICANT_SUCCESS',
  GET_ACCREDITATIONS: DOCUMENT + 'GET_ACCREDITATIONS',
  GET_ACCREDITATIONS_SUCCESS: DOCUMENT + 'GET_ACCREDITATIONS_SUCCESS',
  LOAD_APPLICANT_DATA: DOCUMENT + 'LOAD_APPLICANT_DATA',
  LOAD_FORM_DATA: DOCUMENT + 'LOAD_FORM_DATA',
  LOAD_FORM_DATA_SUCCESS: DOCUMENT + 'LOAD_FORM_DATA_SUCCESS',
  OPEN_POPUP: DOCUMENT + 'OPEN_POPUP',
  START_NOT_SCHEDULED_INTERVIEW: DOCUMENT + 'START_NOT_SCHEDULED_INTERVIEW',
  UPDATE_INTERVIEW: DOCUMENT + 'UPDATE_INTERVIEW',
  UPDATE_INTERVIEW_FAIL: DOCUMENT + 'UPDATE_INTERVIEW_FAIL',
  UPDATE_INTERVIEW_SUCCESS: DOCUMENT + 'UPDATE_INTERVIEW_SUCCESS',

  approveApplicant: payload => ({ type: actions.APPROVE_APPLICANT, payload }),
  approveApplicantFail: payload => ({ type: actions.APPROVE_APPLICANT_FAIL, payload }),
  approveApplicantSuccess: payload => ({ type: actions.APPROVE_APPLICANT_SUCCESS, payload }),
  changeProperty: payload => ({ type: actions.CHANGE_PROPERTY, payload }),
  clearStore: payload => ({ type: actions.CLEAR_STORE, payload }),
  denyApplicant: payload => ({ type: actions.DENY_APPLICANT, payload }),
  denyApplicantFail: payload => ({ type: actions.DENY_APPLICANT_FAIL, payload }),
  denyApplicantSuccess: payload => ({ type: actions.DENY_APPLICANT_SUCCESS, payload }),
  getAccreditations: payload => ({ type: actions.GET_ACCREDITATIONS, payload }),
  getAccredutationsSuccess: payload => ({ type: actions.GET_ACCREDITATIONS_SUCCESS, payload }),
  loadApplicantData: payload => ({ type: actions.LOAD_APPLICANT_DATA, payload }),
  loadFormData: payload => ({ type: actions.LOAD_FORM_DATA, payload }),
  loadFormDataSuccess: payload => ({ type: actions.LOAD_FORM_DATA_SUCCESS, payload }),
  openInterviewPopup: payload => ({ type: actions.OPEN_POPUP, payload }),
  startNotScheduledInterview: payload => ({ type: actions.START_NOT_SCHEDULED_INTERVIEW, payload }),
  updateInterview: payload => ({ type: actions.UPDATE_INTERVIEW, payload }),
  updateInterviewFail: payload => ({ type: actions.UPDATE_INTERVIEW_FAIL, payload }),
  updateInterviewSuccess: payload => ({ type: actions.UPDATE_INTERVIEW_SUCCESS, payload }),
};

export default actions;
